<div class="c-skills -category" id="persoonlijke-vaardigheden">
	<h2>{{ title }}</h2>
	@for (softSkill of softSkills; track softSkill; let i = $index) {
		<div>
			<occupational-profile-soft-skill-item [index]="i" [softSkill]="softSkill"></occupational-profile-soft-skill-item>
		</div>
	}

	@if (softSkills) {
		@for (softSkill of restSoftSkills; track softSkill; let i = $index) {
			<div class="extraSoftSkills">
				<occupational-profile-soft-skill-item [index]="i + softSkills.length" [softSkill]="softSkill"></occupational-profile-soft-skill-item>
			</div>
		}
	}

	@if (hasRestSoftSkills()) {
		<div id="occupational-profile-soft-skill-show-more" class="c-skills__show-extra" (click)="toggleAllSoftSkills($event)">
			<a [ngClass]="showAllSoftSkills ? 'action-hide' : 'action-show'">{{ showAllSoftSkills ? 'Toon minder' : 'Toon meer' }}</a>
		</div>
	}
</div>

